import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  const location = useLocation();

  usePageMeta({
    title: "页面不存在 - 在线视频",
    description: "抱歉，您访问的页面不存在，返回首页继续发现更多视频内容。",
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-md w-full text-center">
          <span className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-primary-50 text-primary-500">
            <i className="ri-emotion-sad-line text-4xl"></i>
          </span>
          <h1 className="mt-6 text-3xl font-bold text-foreground-950">
            页面走丢了
          </h1>
          <p className="mt-3 text-sm text-foreground-500">
            没有找到您要访问的页面：
            <span className="font-mono text-foreground-700">
              {location.pathname}
            </span>
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/category/movie"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-300 text-foreground-700 font-medium whitespace-nowrap hover:border-primary-400 hover:text-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>
              浏览电影
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}